import type { ChromeCopy } from '../types/chrome';

export const chromeRo: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - meniuri cu cod QR pentru restaurante | safestmenu.com',
    defaultDescription:
      'Creează cu SafestMenu pe safestmenu.com un meniu digital multilingv cu cod QR. Clienții scanează; tu actualizezi prețurile. Începe gratuit.',
  },
  header: {
    homeAriaLabel: 'Pagina principală SafestMenu',
    mainNavAriaLabel: 'Principal',
    mobileNavAriaLabel: 'Mobil',
    nav: {
      why: 'De ce SafestMenu',
      howItWorks: 'Cum funcționează',
      aboutUs: 'Despre noi',
    },
    ctaLabel: 'Deschide aplicația',
    openMenuAriaLabel: 'Deschide meniul',
    closeMenuAriaLabel: 'Închide meniul',
  },
  footer: {
    tagline:
      'Meniul cu cod QR pentru restaurante, cafenele și baruri. Ușor de configurat, sigur pentru clienții tăi, prietenos cu natura.',
    siteNavAriaLabel: 'Site',
    legalNavAriaLabel: 'Legal',
    exploreHeading: 'Explorează',
    companyHeading: 'Companie',
    nav: {
      why: 'De ce SafestMenu',
      howItWorks: 'Cum funcționează',
      allergenGuide: 'Ghid UE de alergeni',
      blog: 'Blog',
      openApp: 'Deschide aplicația',
      aboutUs: 'Despre noi',
      impressum: 'Notă legală',
      terms: 'Termeni și condiții',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Creat de',
    copyrightSuffix: 'SafestMenu. Toate drepturile rezervate.',
  },
  consent: {
    message:
      'Folosim cookie-uri pentru analiză și pentru a măsura performanța publicității. Poți accepta sau refuza - site-ul funcționează la fel oricum ai alege. Nu le folosim pentru personalizarea reclamelor.',
    decline: 'Refuz',
    accept: 'Accept',
    settings: 'Setări cookie',
  },
  languageSwitcher: {
    label: 'Schimbă limba',
  },
  localeSuggestion: {
    message: 'Această pagină este disponibilă și în română.',
    accept: 'Vezi în română',
    dismiss: 'Nu, mulțumesc',
  },
  emailCapture: {
    defaultTitle: 'Primește sfaturi despre meniuri în inbox',
    defaultDescription:
      'Notițe practice, ocazionale, despre meniuri, alergeni și cum să conduci un restaurant fără hârtie. Fără spam.',
    defaultPlaceholder: 'tu@restaurant.com',
    defaultButtonLabel: 'Abonează-te',
    emailLabel: 'Adresă de email',
    loadingButtonLabel: 'Se abonează…',
    successMessage: 'Ești pe listă. Urmărește-ți inboxul pentru sfaturi despre meniuri.',
    errorMessage: 'Ceva nu a mers bine. Te rog să încerci din nou peste puțin timp.',
  },
  qrPlate: {
    linkAriaLabel: 'Scanează sau atinge pentru a deschide meniul demo SafestMenu, în direct',
    svgAriaLabelPrefix: 'Cod QR către ',
    caption: 'Scanează sau dă click - e real',
  },
  notFound: {
    seoTitle: 'Pagina nu a fost găsită',
    heading: 'Acest preparat nu e pe meniu.',
    message: 'Pagina pe care o cauți nu există sau a fost mutată.',
    backLabel: 'Înapoi la meniu',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Notițe practice despre meniuri cu cod QR, experiența clienților și cum să conduci un restaurant fără hârtie.',
    eyebrow: 'Blog',
    heading: 'Notițe despre meniuri, clienți și cum să conduci un restaurant fără hârtie.',
    emptyMessage: 'Articole noi sunt pe drum.',
  },
};
